import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchConstants } from "./constantsAPI";
import { useReduxUserSync } from "../utils/hooks/useReduxUserSync";
import { useAuth } from "react-oidc-context";

export default function AppInitializer( {children} ) {
    const dispatch = useDispatch();
    const auth = useAuth();
    const isAuthenticated = auth.isAuthenticated;
    useReduxUserSync();

    const token = useSelector(state => state.auth?.user?.tokens?.access_token);
    const {initialized, loading, error} = useSelector(state => state.constants);
    const isPublicRoute = ['/login', '/unauthorized'].includes(location.pathname);

    useEffect(() => {
        if(!initialized && !error && !loading && token) {
            dispatch(fetchConstants());
        }
    }, [initialized, loading, error, dispatch, token]);

    useEffect(() => {
        if (!isPublicRoute && isAuthenticated === false) {
          console.warn('User not authenticated, redirecting to login');
          window.location.href = '/login';
        }
      }, [isAuthenticated, isPublicRoute]);
       
      useEffect(() => {
        if (!isPublicRoute && isAuthenticated && (loading || !initialized)) {
          const timeoutId = setTimeout(() => {
            console.warn('App stuck while authenticated, forcing redirect');
            window.location.href = '/';
          }, 10000);
          return () => clearTimeout(timeoutId);
        }
      }, [isAuthenticated, loading, initialized, isPublicRoute]);

    // console.log('reload',{
    //     'public': isPublicRoute,
    //     'init': initialized,
    //     'loading': loading,
    //     'error': error,
    //     'dispatch': dispatch,
    //     'token': token,
    // });
    if(!isPublicRoute && (loading || !initialized)){
        return <div>Loading application data...</div>
    }

    if(error){
        return <div>Error loading application data: {error}</div>
    }

    return children;
}